<template>
    <div class="dashboard-reconnect">
        <div id="divReconnectContent" class="text-center">
            <div id="divReconnectContentMessage">
                <h4>{{ $t("message.reconnectHeading") }}</h4><br />
                <p>{{ $t("message.reconnectMessage") }}</p> 
            </div>            

            <hr />

            <div id="divReconnectContentTerms">
                <input id="chkReconnectTermsAgree" type="checkbox" name="chkReconnectTermsAgree" class="checkbox-inline" v-model="reconnectTermsAccepted" aria-required="true" />
                <label for="chkReconnectTermsAgree">{{ $t("message.terms") }}</label>
            </div>

            <div id="divReconnectContentButtons" class="top10">
                <button id="btnConnect" type="button" class="btn" :class="reconnectTermsAccepted ? 'btn-connect' : 'btn-secondary'" 
                            :disabled="!reconnectTermsAccepted" @click.prevent="btnConnectClick" aria-label="Connect">{{ $t("message.connect") }}</button>
                <button id="btnCancel" type="button" class="btn btn-primary" @click.prevent="btnCancelClick" aria-label="Cancel">{{ $t("message.cancel") }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        name: 'Reconnect',
        data() {
            return {
                reconnectTermsAccepted: false
            }
        },
        methods: {
            btnConnectClick() {
                if (this.reconnectTermsAccepted) {
                    this.reconnectSoftArm();                    
                } else {
                    this.showError("Please accept the Terms before proceeding to connect the meter.");
                }
            },
            reconnectSoftArm() {
                axios({
                    method: "POST",
                    url: this.$httpAxiosBaseUrl() + "Reconnect/ReconnectSoftArm",
                    data: {
                        termsAccepted: this.reconnectTermsAccepted
                    }
                }).then(result => {
                    var response = result.data;
                    if (response) {
                        this.redirectToHome();
                    } else {
                        this.showError("An error occurred while trying to connect the meter, please try again later.");
                    }
                }, error => {
                    console.log(error);
                });
            },
            btnCancelClick() {
                this.redirectToHome();
            },
            redirectToHome() {
                this.$router.push({ name: 'Home' });
            },
            showError(message) {
                this.$toasted.global.error(message);
                this.$announcer.set(message);
            }
        }
    }
</script>

<style scoped>
.dashboard-reconnect #divReconnectContent {
    width: 50%;
    margin: 0 auto;
}    

.dashboard-reconnect #divReconnectContentButtons .btn-connect {
    color: #fff !important;
    background-color: #5cb85c !important;
    border-color: #4cae4c !important;
}

.dashboard-reconnect #divReconnectContentTerms input {
    margin-top: 0;
}
</style>